import React, { useEffect, useState } from "react";
import { Siren, ArrowRight, ShieldCheck, RefreshCw } from "lucide-react";
import api from "../../lib/api";

const sevDot = (s) => s === "high" ? "bg-red-500" : s === "medium" ? "bg-amber-500" : "bg-zinc-400";

export default function EarlyWarningInbox({ onOpenClient }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = () => {
    setLoading(true);
    api.get("/admin/enterprise360/alerts/inbox")
      .then(({ data }) => setData(data)).catch(() => setData(null))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const groups = data?.clients || [];
  return (
    <div data-testid="ew-inbox" className="border border-zinc-200 rounded-lg p-4 mb-4">
      <div className="flex items-center justify-between mb-3">
        <div className="text-[11px] font-semibold tracking-[0.16em] uppercase text-[var(--e360-primary)] inline-flex items-center gap-1.5">
          <Siren size={14} /> Portfolio early-warning
          {data && <span data-testid="ew-inbox-total" className="text-zinc-400 font-normal normal-case tracking-normal">· {data.total_active} active across {groups.length} engagement{groups.length === 1 ? "" : "s"}</span>}
        </div>
        <button data-testid="ew-inbox-refresh" onClick={load} className="text-zinc-300 hover:text-zinc-600 p-1" title="Refresh"><RefreshCw size={14} /></button>
      </div>
      {loading ? <div className="text-sm text-zinc-400 py-4 text-center">Loading…</div> : groups.length === 0 ? (
        <div data-testid="ew-inbox-empty" className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg py-4 text-center">
          <ShieldCheck size={16} className="inline mr-1" /> All engagements clear — no active early-warning alerts.
        </div>
      ) : (
        <div className="divide-y divide-zinc-100">
          {groups.map((g) => (
            <div key={g.client_id} data-testid={`ew-inbox-client-${g.client_id}`} className="flex items-start justify-between gap-3 py-2.5">
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-medium text-black">{g.client_name}</span>
                  {g.high > 0 && <span className="text-[10px] font-bold text-white bg-red-500 rounded-full px-2 py-0.5">{g.high} high</span>}
                  {g.new > 0 && <span className="text-[10px] font-semibold text-amber-700 bg-amber-50 border border-amber-200 rounded-full px-2 py-0.5">{g.new} new</span>}
                  <span className="text-[11px] text-zinc-400">{g.alerts.length} active</span>
                </div>
                <div className="mt-1 space-y-0.5">
                  {g.alerts.slice(0, 3).map((a) => (
                    <div key={a.id} className="flex items-center gap-1.5 text-[12px] text-zinc-600 truncate">
                      <span className={`w-1.5 h-1.5 rounded-full flex-none ${sevDot(a.severity)}`} />
                      <span className="truncate">{a.title}{a.value_label ? ` · ${a.value_label} exposed` : ""}</span>
                    </div>
                  ))}
                  {g.alerts.length > 3 && <div className="text-[11px] text-zinc-400">+{g.alerts.length - 3} more</div>}
                </div>
              </div>
              <button data-testid={`ew-inbox-open-${g.client_id}`} onClick={() => onOpenClient?.(g.client_id)}
                className="flex-none text-[12px] tracking-[0.12em] uppercase text-[var(--e360-primary)] inline-flex items-center gap-1 hover:opacity-80">
                Triage <ArrowRight size={14} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
